import { API, Competition, Endpoints, Nullable } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
import { STATUSES } from "_competition/const";
import { useEffect, useMemo, useState } from "react";
import { CompetitionDisableBtnStatus } from "shared/pages/opencallsPage/GetCompetitionItem/ActionsButtons";

export interface StatusesInfo {
    allowedMax?: Nullable<number>,
    allowedCurrent?: Nullable<number>,
    allowedMaxBriefs?: Nullable<number>,
    allowedCurrentBriefs?: Nullable<number>,
}

export interface AllowedData {
    allowedInfo?: CompetitionDisableBtnStatus[],
    allowedStatus?: StatusesInfo,
}

const ALLOWED_STATUSES = [STATUSES.Open];

export const MAX_BRIEF_COUNT = 0;

export const useGetLimitSendCompetition = (competition: Competition): [AllowedData] => {
    const [statusesInfo, setStatusesInfo] = useState<StatusesInfo>();
    const [statuses, setStatuses] = useState<CompetitionDisableBtnStatus[]>([]);
    const [error, setError] = useState(false);
    const profile = useProfile();

    const isBrief = useMemo(() => (competition?.isBriefCompetition) , [competition]);
    const isModer = useMemo(() => {
        if (profile && competition) {
          return (bProfile.isModer(profile) ||
            competition?.moderatorID?.includes(profile?.accountId))
        }
      }, [profile, competition])

    const isParticipant = useMemo(
        //@ts-ignore
        () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)) 
    , [competition, profile])

    const isPendingParticipant = useMemo(
        //@ts-ignore
        () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)) 
    , [competition, profile])

    const onSetStatuses = (status: CompetitionDisableBtnStatus) => {
        if (status !== CompetitionDisableBtnStatus.none)
            setStatuses([...statuses?.filter((s) => s !== status), status])
    }

    const onSetStatusesInfo = (statusesList: StatusesInfo) => {
        setStatusesInfo({...statusesInfo, ...statusesList})
    }

    useEffect(() => {
        if (
            competition.maxParticipantsCount &&
            competition.maxParticipantsCount > 0 && 
            ALLOWED_STATUSES?.includes(competition?.status)
        ) {

            setStatusesInfo(
                { 
                    allowedMax: competition.maxParticipantsCount, 
                    allowedCurrent: competition?.participantsCount || 0
                }
            )

            if (competition?.participantsCount && 
                competition?.participantsCount >= competition.maxParticipantsCount 
            ) {
                onSetStatuses(CompetitionDisableBtnStatus.max_projects)
            }
 
        }  
        
        if (isBrief && !isModer) {
            if (profile) {
                API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/GetUserBriefParticipantsCount')
                .get()
                .addQuery('accountId', profile?.accountId)
                .send()
                .then((r) => r.json())
                .then((briefCount) => {
                    onSetStatuses( 
                        briefCount > MAX_BRIEF_COUNT ? 
                            CompetitionDisableBtnStatus.max_briefs : 
                            isPendingParticipant ? 
                            CompetitionDisableBtnStatus.participant_pending :
                            CompetitionDisableBtnStatus.none
                    )

                    if (briefCount > MAX_BRIEF_COUNT) {
                        onSetStatusesInfo(
                            {
                                allowedMaxBriefs: MAX_BRIEF_COUNT + 1,
                                allowedCurrentBriefs: MAX_BRIEF_COUNT + 1
                            }
                        )
                    }
                })
                .catch((e) => setError(true))
            }
        } 
        
        if (isPendingParticipant) 
            onSetStatuses(CompetitionDisableBtnStatus.participant_pending)

      }, [
        competition, 
        isModer, 
        isBrief, 
        isParticipant, 
        isPendingParticipant, 
        profile,
    ])

      return useMemo(() => ([{ allowedInfo: statuses, allowedStatus: statusesInfo }]), [statuses, statusesInfo])
}import { API, Competition, Endpoints, Nullable } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
import { STATUSES } from "_competition/const";
import { useEffect, useMemo, useState } from "react";
import { CompetitionDisableBtnStatus } from "shared/pages/opencallsPage/GetCompetitionItem/ActionsButtons";

export interface StatusesInfo {
    allowedMax?: Nullable<number>,
    allowedCurrent?: Nullable<number>,
    allowedMaxBriefs?: Nullable<number>,
    allowedCurrentBriefs?: Nullable<number>,
}

export interface AllowedData {
    allowedInfo?: CompetitionDisableBtnStatus[],
    allowedStatus?: StatusesInfo,
}

const ALLOWED_STATUSES = [STATUSES.Open];

export const MAX_BRIEF_COUNT = 0;

export const useGetLimitSendCompetition = (competition: Competition): [AllowedData] => {
    const [statusesInfo, setStatusesInfo] = useState<StatusesInfo>();
    const [statuses, setStatuses] = useState<CompetitionDisableBtnStatus[]>([]);
    const [error, setError] = useState(false);
    const profile = useProfile();

    const isBrief = useMemo(() => (competition?.isBriefCompetition) , [competition]);
    const isModer = useMemo(() => {
        if (profile && competition) {
          return (bProfile.isModer(profile) ||
            competition?.moderatorID?.includes(profile?.accountId))
        }
      }, [profile, competition])

    const isParticipant = useMemo(
        //@ts-ignore
        () => (competition && competition?.participantAccountIds?.includes(profile?.accountId)) 
    , [competition, profile])

    const isPendingParticipant = useMemo(
        //@ts-ignore
        () => (competition && competition?.pendingParticipantsIds?.includes(profile?.accountId)) 
    , [competition, profile])

    const onSetStatuses = (status: CompetitionDisableBtnStatus) => {
        if (status !== CompetitionDisableBtnStatus.none)
            setStatuses([...statuses?.filter((s) => s !== status), status])
    }

    const onSetStatusesInfo = (statusesList: StatusesInfo) => {
        setStatusesInfo({...statusesInfo, ...statusesList})
    }

    useEffect(() => {
        if (
            competition.maxParticipantsCount &&
            competition.maxParticipantsCount > 0 && 
            ALLOWED_STATUSES?.includes(competition?.status)
        ) {

            setStatusesInfo(
                { 
                    allowedMax: competition.maxParticipantsCount, 
                    allowedCurrent: competition?.participantsCount || 0
                }
            )

            if (competition?.participantsCount && 
                competition?.participantsCount >= competition.maxParticipantsCount 
            ) {
                onSetStatuses(CompetitionDisableBtnStatus.max_projects)
            }
 
        }  
        
        if (isBrief && !isModer) {
            if (profile) {
                API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/GetUserBriefParticipantsCount')
                .get()
                .addQuery('accountId', profile?.accountId)
                .send()
                .then((r) => r.json())
                .then((briefCount) => {
                    onSetStatuses( 
                        briefCount > MAX_BRIEF_COUNT ? 
                            CompetitionDisableBtnStatus.max_briefs : 
                            isPendingParticipant ? 
                            CompetitionDisableBtnStatus.participant_pending :
                            CompetitionDisableBtnStatus.none
                    )

                    if (briefCount > MAX_BRIEF_COUNT) {
                        onSetStatusesInfo(
                            {
                                allowedMaxBriefs: MAX_BRIEF_COUNT + 1,
                                allowedCurrentBriefs: MAX_BRIEF_COUNT + 1
                            }
                        )
                    }
                })
                .catch((e) => setError(true))
            }
        } 
        
        if (isPendingParticipant) 
            onSetStatuses(CompetitionDisableBtnStatus.participant_pending)

      }, [
        competition, 
        isModer, 
        isBrief, 
        isParticipant, 
        isPendingParticipant, 
        profile,
    ])

      return useMemo(() => ([{ allowedInfo: statuses, allowedStatus: statusesInfo }]), [statuses, statusesInfo])
}